export const OrgAudience = {
  PURCHASER: 'purchaser',
  SUPPLIER: 'supplier',
} as const;

export type AllowedOrgType = (typeof OrgAudience)[keyof typeof OrgAudience];

export interface RouteHandle {
  /** Only these org types can access this route. Omit = unrestricted. */
  allowedOrgTypes?: AllowedOrgType[];

  // future: allowedRoles?, requiredTier?, requiredFeature?
}

export const ANY_ORG = {
  allowedOrgTypes: [OrgAudience.PURCHASER, OrgAudience.SUPPLIER],
} satisfies RouteHandle;
export const SUPPLIER_ONLY = { allowedOrgTypes: [OrgAudience.SUPPLIER] } satisfies RouteHandle;
export const PURCHASER_ONLY = { allowedOrgTypes: [OrgAudience.PURCHASER] } satisfies RouteHandle;
